<template>
  <div class="Branch">
    <div class="page-title">{{ title }}</div>
    <ATable
      ref="table"
      max-height="750px"
      :data="items"
      :search_field="search_field"
      :placeholder="placeholder"
      :disable_insert="!has_grant_write"
      hide-pagination
      border
      @row-click="handleClickRow"
      @clicked-create="handleClickedCreate"
    >
      <el-table-column 
        type="index" 
        label="No" 
        :index="handleIndex" 
        :width="$width.index"
      />
      <el-table-column 
        prop="name" 
        label="부서명" 
        width="150"
      />
      <el-table-column
        label="부서원"
        width="60"
        class-name="cell-number"
        :formatter="util.numberFormat"
      >
        <template slot-scope="scope">
          {{ displayUserCount(scope.row.id)}}
        </template>
      </el-table-column>
      <el-table-column 
        prop="desc" 
        :label="$t('lang.notes')"
      />
      <el-table-column
        prop="created_user_name"
        :label="$t('lang.created_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="modified_user_name"
        :label="$t('lang.modified_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="created_at"
        :label="$t('lang.created_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <el-table-column
        prop="modified_at"
        :label="$t('lang.modified_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
    </ATable>

    <el-dialog
      top="0"
      width="400px"
      custom-class="form-dialog"      
      :title="title"
      :visible.sync="dialog_visible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      destroyOnClose
      @opened="handleOpened"
    >
      <BranchForm 
        ref="form" 
        v-if="dialog_visible"
        :data="form_data" 
        :has_grant_write="has_grant_write"
        @completed="handleCompleted" 
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import BranchForm from "./BranchForm";

export default {
  name: "Branch",
  mixins: [form_container, authority_level],
  components: { BranchForm },
  data() {
    return {
      title: this.$t('title.branch'),
      dialog_visible: false,
      form_data: undefined,
      search_field: ["name", "desc"],
      placeholder: "부서명, 비고",
    };
  },
  computed: {
    ...mapGetters(["table_user", "table_branch"]),
    items: function () {
      return this.table_branch;
    },
    has_grant_write() {      
      return this.isWriteLevel('branch');
    },
  },
  methods: {
    handleClickRow(data) {
      this.openDialog(data);
    },
    openDialog(data) {
      // let clone = data ? Object.assign({}, data) : undefined;
      let clone = data ? this.util.looseClone(data) : undefined;
      this.form_data = clone;
      this.dialog_visible = true;
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickedCreate() {
      this.openDialog();
    },
    displayUserCount(branch_id) {
      let data = this.table_user.filter((u) => u.branch_id === branch_id);
      return data.length;
    },
    handleCompleted() {
      this.dialog_visible = false;
      this.form_data = undefined;
    },
  },
};
</script>
